import { combineReducers } from 'redux';

import { flyoutReducer, alertReducer } from '../Dashboard/reducers';
import { sessionReducer, loginAlertReducer } from '../Session/reducers';
import { visitsReducer } from '../Visits/reducers';
import { rejectedReducer } from '../Rejected/reducers';
import { businessReducer } from '../Business/reducers';
import { agenciesReducer } from '../Agencies/reducers';
import { procedureReducer } from '../Procedure/reducers';
import { reasonReducer } from '../ReasonCode/reducers';
import { payersReducer } from '../Payers/reducers';
import { resolutionReducer } from '../ResolutionCode/reducers';
import { taskReducer } from '../TaskCode/reducers';
import { requiredFieldsReducer } from '../RequiredFields/reducers';
import { exceptionReducer } from '../ExceptionCodes/reducers';

const rootReducer = combineReducers({
  session: sessionReducer,
  loginAlert: loginAlertReducer,
  alert: alertReducer,
  flyout: flyoutReducer,
  visits: visitsReducer,
  rejected: rejectedReducer,
  business: businessReducer,
  agencies: agenciesReducer,
  procedure: procedureReducer,
  reason: reasonReducer,
  payers: payersReducer,
  resolution: resolutionReducer,
  task: taskReducer,
  requiredFields: requiredFieldsReducer,
  exception: exceptionReducer,
});

export default rootReducer;
